import set from 'lodash/set';
import get from 'lodash/get';
import {
  FETCH_ROUTE_BY_ID,
  FETCH_ROUTES_BY_RIDES,
  IS_LOADING,
  HEATMAP_IS_LOADING,
  CLEAR_HEAT_MAP_DATA,
} from '../actions/routes';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_ROUTE_BY_ID: {
      const newState = { ...state };
      set(newState, `byId.${get(action, 'payload._id')}`, action.payload);
      return newState;
    }
    case FETCH_ROUTES_BY_RIDES:
      return {
        ...state,
        heatMapData: action.payload,
      };
    case CLEAR_HEAT_MAP_DATA:
      return {
        ...state,
        heatMapData: undefined,
      };
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case HEATMAP_IS_LOADING:
      return {
        ...state,
        heatMapIsLoading: action.payload,
      };
    default:
      return state;
  }
}
